import type { Maybe } from '@adornis/base/utilTypes.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { loadMongoData } from '@adornis/baseql/server/data-loader.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { DateTime } from 'luxon';
import { FamilyRegistration } from './FamilyRegistration.js';

@Entity()
export class FamilyEvent extends MongoEntity {
  static override _class = 'FamilyEvent';
  static override _collectionName = 'family-events';

  @validate(nonOptional())
  @Field(() => String)
  public name: Maybe<string>;

  @validate(nonOptional())
  @Field(() => String)
  public publicName: Maybe<string>;

  @validate(nonOptional())
  @Field(() => DateTime)
  public when: Maybe<DateTime>;

  @Field(() => Int, {
    resolve: function (this: FamilyEvent) {
      return async () => {
        return (await loadMongoData(FamilyRegistration, { eventID: this._id })).length;
      };
    },
  })
  public acceptedCount: Maybe<Int>;

  @Field(() => Int)
  public cameCount: Maybe<Int>;

  @DataLoadedField(() => FamilyRegistration, ({ _id }) => ({ eventID: _id }))
  public registrations: Maybe<FamilyRegistration[]>;
}
